<template>
  <vs-popup title="Edit Intent" :active.sync="popupActive" v-if="popupActive">
    <div class="p-4 space-y-6">
      <div v-if="loadingIntents" class="text-center py-4">
        <vs-loading>Loading existing intents...</vs-loading>
      </div>
      <div v-else v-for="(values, key) in intent.Intent" :key="key" class="space-y-2">
        <button class="icon-button text-danger mt-5" @click="deleteIntent(key)" title="Delete this intent"><i class="far fa-x"></i></button>
        <label class="block font-semibold">{{ key }}</label>
        <v-select v-model="intent.Intent[key]"
                  taggable
                  multiple
                  :close-on-select="false"
                  @new-tag="(newTag) => addTag(key, newTag)"
                  :options="existingIntents[key] || []"
                  placeholder="Add or select values"
                  class="w-full" />
      </div>
      <div class="flex justify-between mt-5">
        <vs-button @click="saveIntent">Save</vs-button>
        <vs-button @click="openAddIntentMenu">Add</vs-button>
        <vs-button @click="askAI">Generate properties using AI</vs-button>
      </div>
    </div>
    <vs-popup style="z-index:999999;" title="Edit Intent" :active.sync="InAddIntentMode" v-if="InAddIntentMode">
      <vs-input label="New Intent" class="w-full mb-5" v-model="newIntent"></vs-input>
      <vs-button @click="addNewIntent">Add new Intent</vs-button>
    </vs-popup>
  </vs-popup>
</template>

<script>
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import SearchService from '@/search/searchService.js'
  import Vue from 'vue'
  export default {
    name: 'IntentEditor',
    components: { vSelect },
    props: ["properties", "isActive"],
    data() {
      return {
        intent: {
          Intent: {}
        },
        existingIntents: {},
        loadingIntents: false,
        InAddIntentMode: false,
        newIntent:""
      }
    },
    mounted() {
      this.loadExistingIntents()
      this.extractIntent()
    },

    computed: {
      popupActive: {
        get() {
          return this.isActive
        },
        set(value) {
          this.$emit('update:isActive', value)
        }
      }
    },

    watch: {
      properties(newValue, oldValue) {
        this.extractIntent()
      }
    },

    methods: {
      loadExistingIntents() {
        this.loadingIntents = true;
        SearchService.getExistingIntents().then((result) => {
          if (result && result.data) {
            this.existingIntents = result.data;
            // Initialize intent structure with existing categories
            Object.keys(result.data).forEach(key => {
              if (!this.intent.Intent[key]) {
                this.$set(this.intent.Intent, key, []);
              }
            });
          }
        }).catch((error) => {
          console.error("Error loading existing intents:", error);
          // Fallback to basic categories
          const basicCategories = {
            System: [],
            Client: [],
            Project: [],
            Role: [],
            ActionType: [],
            LifecycleStage: [],
            Technology: [],
            Environment: [],
            Persona: [],
            Frequency: [],
            SensitivityLevel: []
          };
          this.existingIntents = basicCategories;
          Object.keys(basicCategories).forEach(key => {
            if (!this.intent.Intent[key]) {
              this.$set(this.intent.Intent, key, []);
            }
          });
        }).finally(() => {
          this.loadingIntents = false;
        });
      },
      addTag(key, newTag) {
        if (!this.intent.Intent[key]) {
          this.$set(this.intent.Intent, key, []);
        }
        if (!this.intent.Intent[key].includes(newTag)) {
          this.intent.Intent[key].push(newTag)
        }
      },
      saveIntent() {
        this.$emit("save-intent", this.intent.Intent)
      },

      openAddIntentMenu() {
        this.InAddIntentMode = true
      },

      addNewIntent() {
        this.$set(this.intent.Intent, this.newIntent, []);
        this.newIntent = ""
        this.InAddIntentMode = false
      },

      deleteIntent(intent) {
        Vue.delete(this.intent.Intent,intent)
      },

      extractIntent() {
        if (this.properties != null) {
          var json = JSON.parse(this.properties)
          if (json.hasOwnProperty("Intent")) {
            this.intent.Intent = json["Intent"]
          }
        }
      },
      askAI() {
        this.$vs.notify({
          title: "Generating...",
          color: "success",
          iconPack: "feather",
          position: "top-center",
          icon: "icon-alert-circle",
        });

        // Pass existing intents to AI for better suggestions
        const aiData = {
          existingIntents: this.existingIntents,
          currentIntent: this.intent.Intent
        };

        this.$emit('ask-ai', aiData)
      }
    }
  }
</script>

<style scoped>
  /* Optional: basic layout */
  label {
    display: block;
    margin-bottom: 4px;
  }

  .icon-button {
    float:right;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    background: transparent;
    color: var(--neutral);
    cursor: pointer !important;
  }

    .icon-button:hover {
      background: var(--neutral-light);
      border-radius: 50%;
    }
</style>
